import { render, staticRenderFns } from "./GbpManager.vue?vue&type=template&id=0f4fbaea&scoped=true"
import script from "./GbpManager.vue?vue&type=script&lang=js"
export * from "./GbpManager.vue?vue&type=script&lang=js"
import style0 from "./GbpManager.vue?vue&type=style&index=0&id=0f4fbaea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f4fbaea",
  null
  
)

export default component.exports